import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';
import { SsoVendor, vendorContents } from '../Types';

interface Props {
  selected: SsoVendor;
  onSelect: (vendor: SsoVendor) => void;
}

const VendorPicker: React.FC<Props> = ({ selected, onSelect }) => (
  <div role="radiogroup" className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {vendorContents.map((content) => {
      const isSelected = content.vendor === selected;

      return (
        <button
          key={content.vendor}
          type="button"
          role="radio"
          aria-checked={isSelected}
          onClick={() => onSelect(content.vendor)}
          className={`flex items-start gap-3 rounded-lg border p-4 text-left ${
            isSelected ? 'border-primary bg-secondary ring-1 ring-primary' : 'border-border bg-card'
          }`}
          data-intercom-target="sso-vendor-radio"
        >
          <span
            aria-hidden="true"
            className={`mt-0.5 h-4 w-4 shrink-0 rounded-full border-2 ${
              isSelected ? 'border-primary bg-primary' : 'border-border bg-card'
            }`}
          />
          <span>
            <span className="block text-sm font-semibold text-foreground">
              <T kind={content.name} />
            </span>
            <span className="block text-xs text-muted-foreground">
              <T kind={content.description} />
            </span>
          </span>
        </button>
      );
    })}
  </div>
);

export default observer(VendorPicker);
